/**
 * Fixed Header with headroom.js
 * @dependencies headroom.js
 */

import Headroom from 'headroom.js';
import $ from 'jquery';

// Header Element
const headerEl = document.querySelector('.js-fixed-header');
const sizeChangeEvents = ['resize', 'orientationchange'];

if (headerEl) {
  const calcHeaderHeight = () => {
    const headerHeight = headerEl.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-height',
      ` ${headerHeight}px`
    );
  };

  window.fixedHeader = {};

  // Headroom Options
  const fixedHeader = new Headroom(headerEl, {
    offset: 0,
    tolerance: {
      up: 0,
      down: 12,
    },
    classes: {
      // when element is initialised
      initial: 'initialized',
      // when scrolling up
      pinned: 'is-pinned',
      // when scrolling down
      unpinned: 'is-unpinned',
      // when above offset
      top: 'is-top',
      // when below offset
      notTop: 'is-not-top',
      // when at bottom of scoll area
      bottom: 'is-bottom',
      // when not at bottom of scroll area
      notBottom: 'is-not-bottom',
    },
  });

  window.addEventListener('load', function () {
    fixedHeader.init();

    sizeChangeEvents.forEach((event) => {
      window.addEventListener(event, debounce(calcHeaderHeight));
    });
  });

  // Prevent header to show on close reveal
  const reveals = document.getElementsByClassName('reveal');
  for (let index = 0; index < reveals.length; index++) {
    const reveal = reveals[index];

    $(reveal).on('closed.zf.reveal', function () {
      headerEl.style.transition = 'none';
      setTimeout(() => {
        headerEl.style.transition = '';
      }, 100);
    });
  }
}

// Debounce the event to avoid too many triggers
function debounce(func, timeout = 250) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
